import Button from 'antd-mobile/lib/button/index';
export default Button;



// WEBPACK FOOTER //
// ./components/button/index.tsx